import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Flex } from "rebass";
import { NumericPad } from "../product/NumericPad";
import { getLocalizedString } from "../../utils";
import sizeSort from "../../utils/sizeSort";

const availabilityColorsMap = {
  green: "#249d4e",
  yellow: "#cea418",
  red: "#f04836",
};

const AvailabilityOrder = ({
  element,
  id,
  doorId,
  type,
  editingMobile,
  setEditingMobile,
}) => {
  const { me } = useSelector((state) => state.yodaStakeholders);

  return (
    <Flex width="calc(66.6vw - 13px)" flexDirection="column" bg="#303130">
      {/*numpad */}
      <Flex
        width="100%"
        flexDirection="column"
        sx={{
          position: "relative",
        }}
      >
        <Box
          px="20px"
          width="100%"
          sx={{
            display: "grid",
            gridTemplateColumns: "25%  75%",
            gap: "10px",
            color: "white",
            fontSize: "9px",
            marginTop: "10px",
          }}
        >
          <Box></Box>
          <Box>
            DISP.
            <strong style={{ fontSize: "14px", marginLeft: "10px" }}>
              {getLocalizedString("QTA")}
            </strong>
          </Box>
        </Box>
        {element?.values?.sort(sizeSort).map((val, i) => {
          const isEdited = editingMobile === val.sizeCode;
          return (
            <Box
              px="20px"
              width="100%"
              sx={{
                display: "grid",
                gridTemplateColumns: "25%  75%",
                gap: "10px",
                ...(editingMobile !== null &&
                  !isEdited && {
                    opacity: 0.5,
                    pointerEvents: "none",
                  }),
              }}
              mb="14px"
              key={`size-${i}-${val.size}`}
            >
              <Box
                sx={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "white",
                  position: "relative",
                  top: "3px",
                }}
              >
                {val.size}
              </Box>
              <Flex mt="7px" maxHeight="25px">
                <Flex
                  bg={
                    val.quantity > 0
                      ? availabilityColorsMap["green"]
                      : availabilityColorsMap["red"]
                  }
                  width="30%"
                  justifyContent="center"
                  alignItems="center"
                >
                  <span style={{ color: "white" }}>
                    {me?.role.includes?.("CustomerCare") ||
                    me?.role.includes?.("Agents") ||
                    me?.role.includes?.("Customer")
                      ? val.quantity
                      : ""}
                  </span>
                </Flex>
                <Flex width="60%" justifyContent="center" alignItems="center">
                  <NumericPad
                    index={i}
                    id={id}
                    type={type}
                    sizeCode={val.sizeCode}
                    door={doorId}
                    color={element.code}
                    quantity={
                      element.values.filter(
                        (f) => f.sizeCode == val.sizeCode,
                      )[0].quantity
                    }
                    isCart
                    {...{ editingMobile, setEditingMobile }}
                  ></NumericPad>
                </Flex>
              </Flex>
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default AvailabilityOrder;
